/**
 * Format a date in yyyy/mm/dd format for South African audiences
 * @param {string|Date} date - The date to format
 * @returns {string} Formatted date string in yyyy/mm/dd format
 */
export const formatDate = (date) => {
  if (!date) return '';
  
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  
  return `${year}/${month}/${day}`;
};
